var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _g2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g3, _g4, _g5, _g6, _path28, _path29, _path30, _path31, _g7, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 354.4 75.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #095da4;\n      }\n\n      .cls-14 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-15 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-3 {\n        fill: #ff9f1c;\n      }\n\n      .cls-4 {\n        fill: #d0dcee;\n      }\n\n      .cls-5 {\n        fill: none;\n      }\n\n      .cls-6 {\n        fill: #19345d;\n      }\n\n      .cls-16 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-17 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-7 {\n        fill: #ffd880;\n      }\n\n      .cls-8 {\n        fill: #f2f8fd;\n      }\n\n      .cls-9 {\n        fill: #0a131e;\n      }\n\n      .cls-10 {\n        fill: #28b6f4;\n      }\n\n      .cls-18 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-11 {\n        fill: #f72f43;\n      }\n\n      .cls-19 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-12 {\n        fill: #ffca28;\n      }\n\n      .cls-20 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-13 {\n        fill: #e2212e;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 305.4,
    y: 19.9,
    width: 49,
    height: 5.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 305.4,
    y: 21.2,
    width: 49,
    height: 5.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 318,
    y: 30.5,
    width: 13.3,
    height: 45.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 324.7,
    y: 29.2,
    width: 9.3,
    height: 46.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 327.4,
    y: 33.2,
    width: 6.7,
    height: 42.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 327.4,
    y: 30.5,
    width: 13.3,
    height: 45.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 330,
    y: 31.9,
    width: 10.7,
    height: 44
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M332,8.6c-2.4-7.4-2.4-7.4-2.4-7.5,0-.2.3-.3.4,0,0,.3,1.7,5.4,2.4,7.4,0,.3-.3.4-.4.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M327.5,8.7l1.9-8.1c0-.3.4-.2.4,0l-1.9,8.1c0,.3-.4.2-.4,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M330.4.6v8.5c0,.3-.2.5-.6.5s-.5-.2-.5-.5V.6c0-.4.5-.6.7-.5.3,0,.4.3.4.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M335.9,8.7v3.2h-12.1v-3.2c0-.2.2-.4.4-.4h11.2c.2,0,.4.2.4.4Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M335.9,9.7v2.1h-12.1v-3.2c0-.2.2-.4.4-.4h1.2c0,.3.1.5.3.7,1.3,1.1,7.2.5,10.1.8,0,0,0,0,0,0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M346.3,18.7c-.5.1-.9.2-1.4.3l.8-.5h-31c-.2,0-1.7.1-1.8,0-.1-.2.1-.3.3-.4,1.7-.6,3.4-1.2,5.1-1.7.8-.3,1.7-.5,2.6-.8.9-.2,3.7-.5,3.1-2.3-.2-.5-.5-.8-1-1.1-.3-.2-.8-.4-1-.8-.5-.9.5-1,1.1-1,.4,0,.8,0,1.2-.1,2.2-.1,9.5-.1,12.6.3.5,0,1.5,0,1.4.8,0,.7-1,1-1.6,1.4-.7.6-.7,1.4.5,2,1.7.8,4.7,1.7,6.4,2.2,1,.3,1.9.5,2.8.8.6.1.6.6,0,.8Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M346.3,18.7c-.5.1-.9.2-1.4.3l.8-.5h-31c-.2,0-1.7.1-1.8,0-.1-.2.1-.3.3-.4,1.7-.6,3.4-1.2,5.1-1.7.8-.3,1.7-.5,2.6-.8.9-.2,3.7-.5,3.1-2.3-.2-.5-.5-.8-1-1.1-.3-.2-.8-.4-1-.8-.5-.9.5-1,1.1-1,.4,0,.8,0,1.2-.1.3,0,.6,0,.8,0-.3.2-.6.4-.8.7-.3.4-.4.6-.2,1,.5.9,1.4,1.2,2.4,1.4,3.6.7,5-.1,5,.7,0,.2-.2.3-.4.4-2.4,1-5.3.5-7.6,1.7-.8.4-.6.9.8.9,6.4,0,12.8,0,19.1,0,1,.3,1.9.5,2.8.8.6.1.6.6,0,.8Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M350.4,19.1v2.8c0,.5-.4.9-.9.9h-39.3c-.5,0-.9-.4-.9-.9v-2.8c0-.5.4-.9.9-.9,6-.2,11.3-.3,18.8-.3,7,0,13.9.1,20.5.3.5,0,.9.4.9.9Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M350.4,19.1v1.1c-2.7.2-5.3-.2-8-.5-8.7-.7-17.4.6-26.1.2-.9,0-1.9-.1-2.6-.8-.3-.3-.4-.7-.5-1,5.1-.2,10.4-.2,15.8-.3,7,0,13.9.1,20.5.3.5,0,.9.4.9.9Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M354.4,22.8v1.4h-9.8c-9.2.5-20.6.5-29.3,0h-9.8v-1.4c0-.9,11-1.7,24.5-1.7s24.5.8,24.5,1.7Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M354.4,24.2c0,.1-.2.2-.5.3s-.8.2-1.4.3c-.6,0-1.4.2-2.3.3s-1.9.2-3,.3c-1.1,0-2.4.2-3.7.2s-2.8.1-4.2.2c-1.5,0-3,0-4.6,0-1.6,0-3.2,0-4.8,0s-3.2,0-4.8,0c-1.6,0-3.1,0-4.6,0-1.5,0-2.9,0-4.2-.2s-2.6-.1-3.7-.2c-1.1,0-2.2-.2-3.1-.3s-1.7-.2-2.3-.3c-.6-.1-1.1-.2-1.4-.3-.3-.1-.5-.2-.5-.3s.2-.2.5-.3c.3-.1.8-.2,1.4-.3s1.4-.2,2.3-.3,1.9-.2,3.1-.3c1.1,0,2.4-.2,3.7-.2s2.8-.1,4.2-.2c1.5,0,3,0,4.6,0s3.2,0,4.8,0,3.2,0,4.8,0c1.6,0,3.1,0,4.6,0,1.5,0,2.9,0,4.2.2s2.6.1,3.7.2c1.1,0,2.2.2,3,.3s1.7.2,2.3.3,1.1.2,1.4.3.5.2.5.3Z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M349,24.2c0,.2-2.1,5.1-2,4.8-.1.3-.5.6-.8.6h-33c-.4,0-.7-.2-.8-.6l-2-4.8c0-.9,38.6-.9,38.6,0h0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M347.7,27.2l-.7,1.8c-.1.3-.5.6-.8.6h-33c-.4,0-.7-.2-.8-.6l-2-4.8c0-.2,3.7-.5,9.3-.6-1.4.7-1.4,2.6,1.5,2.7,8.3.2,16.8-1.5,24.9.3.6.1,1.2.3,1.7.6Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M316.9,24.6v2.5c0,.1-.1.3-.3.3-.2,0-1,0-.8,0-.2,0-.3-.1-.3-.3s0-2.7,0-2.6c0-.1.1-.3.3-.3h.8c.2,0,.3.1.3.3Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M311.7,20.8h-.5c-.2,0-.3-.1-.3-.3v-1.8c0-.2.1-.3.3-.3h.5c.2,0,.3.1.3.3v1.8c0,.2-.1.3-.3.3Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M319,20.8h-.5c-.2,0-.3-.1-.3-.3v-1.8c0-.2.1-.3.3-.3h.5c.2,0,.3.1.3.3v1.8c0,.2-.1.3-.3.3Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M326.3,20.8h-.5c-.2,0-.3-.1-.3-.3v-1.8c0-.2.1-.3.3-.3h.5c.2,0,.3.1.3.3v1.8c0,.2-.1.3-.3.3Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M333.6,20.8h-.5c-.2,0-.3-.1-.3-.3v-1.8c0-.2.1-.3.3-.3h.5c.2,0,.3.1.3.3v1.8c0,.2-.1.3-.3.3Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M340.8,20.8h-.5c-.2,0-.3-.1-.3-.3v-1.8c0-.2.1-.3.3-.3h.5c.2,0,.3.1.3.3v1.8c0,.2-.1.3-.3.3Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M348.1,20.8h-.5c-.2,0-.3-.1-.3-.3v-1.8c0-.2.1-.3.3-.3h.5c.2,0,.3.1.3.3v1.8c0,.2-.1.3-.3.3Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M323.4,24.5v2.5c0,.2-.1.3-.2.3-.2,0-1,0-.9,0-.2,0-.3-.1-.3-.3s0-2.7,0-2.6c0-.1.1-.2.3-.2h.8c.2,0,.3.1.3.3Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M329.8,24.3v2.5c0,.1-.1.3-.3.3t0,0h-.8c-.2,0-.3-.1-.3-.3s0-2.7,0-2.6c0-.1.2-.3.3-.3h.8c.2,0,.3.1.3.3Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M336.3,24.3v2.5c0,.1-.1.3-.3.3h-.9c-.2,0-.3-.1-.3-.3s0-2.7,0-2.6c0-.1.1-.3.3-.3h.8c.2,0,.3.1.3.3Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M342.7,24.6v2.5c0,.1-.1.3-.2.3h-.9c-.2,0-.3-.1-.3-.3v-2.5h0c0-.2.1-.3.3-.3h.8c.2,0,.3.1.3.3Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M316.7,24.9c0,.2,0,2.7,0,2.6-.2,0-1,0-.8,0-.2,0-.3-.1-.3-.3s0-2.7,0-2.6c.2,0,1,0,.9,0,.2,0,.3.1.3.3Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M323.1,24.7c0,.2,0,2.7,0,2.6-.2,0-1,0-.9,0-.2,0-.3-.1-.3-.3s0-2.7,0-2.6c.2,0,1,0,.8,0,.2,0,.3.1.3.3Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M329.6,24.6v2.5s0,0,0,0,0,0,0,0h-.8c-.2,0-.3-.1-.3-.3s0-2.7,0-2.6h.9c.2,0,.3.1.3.3Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M336,24.6v2.6h-.9c-.2,0-.3-.1-.3-.3s0-2.7,0-2.6c.2,0,1,0,.9,0,.2,0,.3.1.3.3Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M342.5,24.9v2.5h0s0,0,0,0h-.8c-.2,0-.3-.1-.3-.3v-2.5h0s0,0,0,0h.8c.2,0,.3.1.3.3Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M324.6,75.8h5.6c0-3.5-.2-6.9,0-10.4.5-8,0-16,.2-24.1,0-2.3.1-4.6.2-7,0-1.1.1-2.2,0-3.3h-1.3c-.5,0-.2,11-.2,12.3,0,4.7.2,9.8-.5,14.4-.1.9-.5,4.9-2.3,3.1-1-1-1-2.8-1.2-4.1-.3-2.2-1.7-12.5-2.1-15.8-.3-2.6-.7-5.1-1-7.7,0-.6-.2-1.1-.4-1.5-.4-.7-1.7-.5-2.4-.5,1.1,8.5,2.1,16.8,3.7,25.2,1.2,6.4,1.7,12.9,1.6,19.4Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M325.8,29.7h7.7v46.1h-7.7V29.7Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331.5,75.8h2.1v-42.5c-.8.3-1.2,1.3-1.4,2.2-3.1,11.6-5.6,23.7-3.6,35.5.3,2,1,4.2,2.9,4.8Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M329.6,75.8h5.5c0-6.6.4-12.6,1.7-19.3,2.1-11.2,3.7-24.9,3.7-25.2-.6,0-1.2,0-1.8,0-1.7,9.3-2.9,21-4.5,28-.2.7-.3,1.3-.8,1.8-1.4,1.3-1.7-1.4-1.8-3.2-.8-8.3,0-16.7-.2-25v-.2c0-.4,0-.8-.3-1.2-.6-.9-2.6-.2-3,.6-.3.6-.2,1.3-.2,1.9.9,10.2,2,32.5,1.7,41.9Z"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M349,29.6c0,.7-2.5,1.3-6.4,1.7-7.5.8-18.4.8-25.8,0-3.9-.4-6.4-1-6.4-1.7s1.6-1.1,4.2-1.4c8.2-1.3,28.1-1.3,33.5.7.7.2,1,.5,1,.7Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M342.6,31.3c-7.5.8-18.4.8-25.8,0,1.9-.8,23.9-.8,25.8,0Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M339.7,31c-6,.5-14.1.5-20.1,0,5.1-.3,15-.3,20.1,0Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M348,28.9c-3.5,1-6.4.3-10.1-.1-6.5-.7-13.1.4-19.6.9-.9,0-1.9.2-2.7-.3-.5-.3-.9-.8-1.1-1.3,8.2-1.3,28.1-1.3,33.5.7Z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M340.3,32.7c-2.9,24.5-5.3,27.9-5.2,42.6-2.7.2-4-2.1-4.1-4.9-.2-4.9,2.3-7.3,3.7-10.5,1.5-3.4,1.5-7.2,1.8-10.9.4-4.7,1.3-9.4,2.5-14,.2-1,.5-1.8,1.3-2.3Z"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M331.8,60.4c-.4.2-.9,0-1.1-.3-.6-.7-.6-.9-.8-24.9,0-.6,0-1.3.3-1.8.2-.3.6-.5,1.1-.6.2,8.3-.6,16.7.2,25,0,.4.1,1.7.4,2.6Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M336.7,16.3c.1,0,.1-.3,0-.4,0-.1-.2-.2-.3-.3-.3-.1-1.8-.5-1.5.2,0,.2.4.4.6.5.3,0,1,.2,1.2,0Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M334.4,15c0,0,0-.2,0-.3,0,0-.1-.1-.2-.2-.2,0-1.2-.4-1,.1,0,.2.2.3.4.3.2,0,.7.2.8,0Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M324.4,51c-.2.3-.4.6-.7.9-1.5-5.8-2.4-11.8-2.5-17.8,0-.6,0-1.4.7-1.5,0,.2,0,.5.1.7.3,2.6.7,5.1,1,7.7.4,3.3.9,6.7,1.3,10Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M332.5,71.9c0,.2.2.3.4.4.1,0,.3,0,.4-.2s.1-.3.2-.4c.2-1.2-.5-2.2-.9-2.3-1.1-.2-.2,2.2,0,2.5Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M333.3,69.3c.2.3.4.2.5-.1.1-.7-.3-1.2-.5-1.3-.6-.1-.1,1.2,0,1.4Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M330.4.6v6.8s0,0,0,0c-.4-.2-.4-.6-.5-1,0-1.4-.2-4.9,0-6.3.3,0,.4.3.4.5Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M45,36.9l-6.8,26.3-7.3-26.3h-8.1l-7.2,26.5-6.8-26.5H0l10.4,38h9.6l6.9-26.7,6.9,26.7h9.6l10.4-38h-8.8Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M84.9,68.3c-1.1,0-2.2-.4-2.2-2.5v-16.3h-8v2.2c-1.9-1.7-4.3-2.7-7.2-2.7-7,0-12.5,5.8-12.5,13.2s5.5,13.2,12.5,13.2,6.7-1.6,8.7-4.3c1.6,2.6,4.4,4.3,7.8,4.3s1.6-.3,2.2-.5v-6.6h-1.1ZM69,68.2c-3.4,0-6-2.7-6-6s2.7-6,6-6,6,2.7,6,6-2.7,6-6,6Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M90.7,74.9h8.1V31.5h-8.1v43.4Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M134.2,74.9l-12-13.9,11.1-11.5h-9.7l-8.8,9.1v-27.2h-8v43.4h8v-11.7l8.9,11.7h10.5Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M148.5,75.4c7.1,0,13.1-4.2,13.1-11.3,0-14.1-17.5-10.6-17.5-17.2s1.6-3.2,3.7-3.2,4.3,1.2,6.2,3.3l5.6-5.3c-2.8-3.2-7-5.4-11.7-5.4s-12.2,3.6-12.2,11.2c0,12.9,17.5,9.8,17.5,16.5s-1.8,3.5-4.7,3.5-6.2-2-7.6-4.9l-6.9,4.3c2.5,4.8,7.8,8.5,14.4,8.5Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M192.6,62.2c0-7.9-5.4-13.2-13.6-13.2s-13.9,5.3-13.9,13.2,5.7,13.2,14.2,13.2,11.7-3.7,13-9.2h-7.8c-.7,2-2.5,3.2-5.3,3.2s-5.6-2.2-5.9-5.8h19.4v-1.4ZM179.1,55.2c2.7,0,4.3,1.3,5.1,3.5h-10.5c.8-2.2,2.5-3.5,5.4-3.5Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M226.4,68.3c-1.1,0-2.2-.4-2.2-2.5v-16.3h-8v2.2c-1.9-1.7-4.3-2.7-7.2-2.7-7,0-12.5,5.8-12.5,13.2s5.5,13.2,12.5,13.2,6.7-1.6,8.7-4.3c1.6,2.6,4.4,4.3,7.8,4.3s1.6-.3,2.2-.5v-6.6h-1.1ZM210.5,68.2c-3.4,0-6-2.7-6-6s2.7-6,6-6,6,2.7,6,6-2.7,6-6,6Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M247.5,55.8v-6.3h-6v-9.8h-8v9.8h-4.2v6.3h4.2v10c0,5.4,4.6,9.6,9.9,9.6s3.4-.4,4.1-.8v-6.3h-3c-1.7,0-2.9-1.3-2.9-3.4v-9.1h6Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M267.8,55.8v-6.3h-6v-9.8h-8v9.8h-4.2v6.3h4.2v10c0,5.4,4.6,9.6,9.9,9.6s3.4-.4,4.1-.8v-6.3h-3c-1.7,0-2.9-1.3-2.9-3.4v-9.1h6Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M272.8,74.9h8.1V31.5h-8.1v43.4Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M314.1,62.2c0-7.9-5.4-13.2-13.6-13.2s-13.9,5.3-13.9,13.2,5.7,13.2,14.2,13.2,11.7-3.7,13-9.2h-7.8c-.7,2-2.5,3.2-5.3,3.2s-5.6-2.2-5.9-5.8h19.4v-1.4ZM300.6,55.2c2.7,0,4.3,1.3,5.1,3.5h-10.5c.8-2.2,2.5-3.5,5.4-3.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4665457bdaa9fac61e68cc0b46ec17dc.svg";
export { ForwardRef as ReactComponent };